module.exports = __webpack_public_path__ + "img/upload.74b718df.png";